import React from "react";
import { Box, InputLabel, Typography, useTheme } from "@mui/material";
import ReactQuill from "react-quill-new"; // ✅ Direct import
import "react-quill-new/dist/quill.snow.css";

export default function CommonTextEditor({
    text,
    valid,
    value,
    onChange,
    placeholder,
    labelSize,
    labelColor,
    fontWeight,
    borderRadius = "6px",
    error,
    helperText,
    height = 150,
    sx = {},
}) {
    const theme = useTheme();

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["blockquote", "code-block", "link"],
            [{ color: [] }, { background: [] }],
            ["clean"],
        ],
    };

    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "list",
        "bullet",
        "align",
        "blockquote",
        "code-block",
        "link",
        "color",
        "background",
    ];

    return (
        <Box width="100%">
            {text && (
                <Box mb={0.5} display="flex" fontSize="12px" flexDirection={"row"}>
                    <Box display="flex" fontSize="12px" flexDirection={"column"} flexWrap={"wrap"}>
                        <InputLabel
                            sx={{
                                letterSpacing: "0.03em",
                                marginRight: "2px",
                                fontWeight: fontWeight,
                                fontSize: labelSize || "14px",
                                color: labelColor || "#222222",
                                whiteSpace: "wrap",
                                marginBottom: "0px",
                            }}
                        >
                            {text}
                        </InputLabel>
                    </Box>
                    {valid && (
                        <Typography color="#EF627A" component={"caption"} variant={"body2"}>
                            *
                        </Typography>
                    )}
                </Box>
            )}

            <Box
                sx={{
                    border: `1px solid ${error
                            ? theme.palette.error.main
                            : theme?.palette?.bgSkyBlue?.main || theme.palette.divider
                        }`,
                    borderRadius: borderRadius,
                    overflow: "hidden",
                    "& .ql-toolbar": {
                        border: "none",
                        borderBottom: `1px solid ${error
                                ? theme.palette.error.main
                                : theme?.palette?.bgSkyBlue?.main || theme.palette.divider
                            }`,
                        backgroundColor: theme.palette.background.paper,
                    },
                    "& .ql-container": {
                        border: "none",
                        fontSize: "14px",
                        minHeight: height,
                        "& .ql-editor": {
                            padding: "10px 12px",
                        },
                    },
                    ...sx,
                }}
            >
                <ReactQuill
                    theme="snow"
                    value={value}
                    onChange={onChange}
                    modules={modules}
                    formats={formats}
                    placeholder={placeholder}
                />
            </Box>
        </Box>
    );
}
